export default __webpack_public_path__ + "static/media/mrgn-logo-green.9cbd7477.svg";